import { FormField, fieldA11y } from '@/components/FormField';
import { Input } from '@/components/ui/input';
import type { ProfileFormApi } from './useProfileForm';

const SLUG_HINT = 'A short id for this profile, unique in the app';

/** Name and slug (the slug is read-only while editing). */
export function ProfileIdentityFields({ form }: { form: ProfileFormApi }) {
  const { values, patch, edit, errorFor, setSlug } = form;
  const slugError = errorFor('slug', values.slug.length > 0);
  return (
    <div className="grid gap-4 sm:grid-cols-2">
      <FormField id="profile-name" label="Name" required error={errorFor('name')}>
        <Input data-testid="profile-name" value={values.name} onChange={(e) => patch({ name: e.target.value })} placeholder="Store release" maxLength={120} {...fieldA11y('profile-name', errorFor('name'))} />
      </FormField>
      <FormField id="profile-slug" label="Slug" required error={slugError} hint={SLUG_HINT}>
        <Input data-testid="profile-slug" value={values.slug} readOnly={edit} onChange={(e) => setSlug(e.target.value)} placeholder="store" className="font-mono sm:text-[13px]" maxLength={63} spellCheck={false} {...fieldA11y('profile-slug', slugError, SLUG_HINT)} />
      </FormField>
    </div>
  );
}
